import React from "react";
import * as CompareSpecsStyles from "../styles/CompareSpecs";
import type { SpecItemType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import CollapsibleList from "./CollapsibleList";
import { shouldShowSpecList } from "../../../utils/utils";
import type { CompareV2LabelType } from "../../../utils/labels";
import { CompareV2Label } from "../../../utils/labels";

type CompareSpecListType = {
    title?: CompareV2LabelType;
    specs: SpecItemType[];
    onlyShowDifferences: boolean;
    showAllSpecs: boolean;
    isMessageLabel: boolean;
    cultureName: string;
    showPrices: boolean;
    isPdf?: boolean;
};

const SpecList = ({
    title,
    specs,
    onlyShowDifferences,
    showAllSpecs,
    isMessageLabel,
    cultureName,
    showPrices,
    isPdf,
}: CompareSpecListType): JSX.Element | null => {
    const show = shouldShowSpecList(onlyShowDifferences, specs);

    return specs.length && show ? (
        <>
            {title && (
                <CompareSpecsStyles.Title>
                    <CompareV2Label label={title} />
                </CompareSpecsStyles.Title>
            )}
            {specs.map((spec) => {
                return (
                    <CollapsibleList
                        key={spec.category}
                        header={spec.category}
                        items={spec.specs}
                        onlyShowDifferences={onlyShowDifferences}
                        showAllSpecs={showAllSpecs}
                        isMessageLabel={isMessageLabel}
                        cultureName={cultureName}
                        showPrices={showPrices}
                        isPdf={isPdf}
                    />
                );
            })}
        </>
    ) : null;
};

export default SpecList;
